export { registreeru };

const registreeru = () => {
    if (MODULE_NAME === "registreeru") {

        if (typeof mid !== 'undefined') {
            MO.startMobileID(mid);
        }
        if (typeof sid !== 'undefined') {
            MO.startSmartID(sid);
        }
        $.fn.isNearTheEnd = function () {
            return 35 + this[0].scrollTop + this.height() >= this[0].scrollHeight;
        };
        $(".disclaimer:checkbox:not(:checked)").attr("disabled", true);
        //$(".disclaimer:checkbox:not(:checked)").attr("disabled", false);
        var ttob;
        var ttpa;
        $(".terms-box").bind("scroll", function () {
            ttob = $(this);
            ttpa = ttob.parent().parent();
            if (ttob.isNearTheEnd()) {
                ttpa.addClass("readed").find("input[type=\'checkbox\']").removeAttr("disabled");
            } else {
                //ttpa.removeClass("readed").find("input[type=\'checkbox\']").attr("disabled", true);
            }
        });
    }
}